import clsx from 'clsx'
import React from 'react'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgArrowSlim from '../../svg/icons/ArrowSlim'
import { Button } from '../shared/Button'
import style from './ComparatorSwiper.module.sass'

type SwiperButtonProps = {
	direction: string
	onClick: () => void
}

export const SwiperButton = React.memo(function SwiperButton(props: SwiperButtonProps) {
	const translate = useTranslate()
	return (
		<div className={clsx(style.button, props.direction === 'previous' ? style.buttonPrevious : style.buttonNext)}>
			<Button
				iconButtonStyle={{ color: 'grey' }}
				icon={{
					aloneStanding: true,
					fillPrimary: true,
					large: true,
					rotatedHorizontally: props.direction === 'previous',
				}}
				ariaLabel={translate('swiperButton.button')}
				onClick={props.onClick}
				label={<SvgArrowSlim />}
			/>
		</div>
	)
})
